import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {deleteDepartments,getDepartments,getDesignation,getEmployee,getProfitCenter,insertDepartments,} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import { getSecureItem } from "../../services/SecureStorage";
export default function Department() {
  const UID = getSecureItem("userId");
  const [addDepartmentModal, setAddDepartmentModal] = useState(false);
  const [editDepartmentModal, setEditDepartmentModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [commonDatas, setCommonDatas] = useState([]);
  const [selectedCommonData, setSelectedCommonData] = useState("");
  const [filterText, setFilterText] = React.useState("");
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [EmployeeDetails, setEmployeeDetails] = useState([])
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const [DepartmentIdToDelete, setDepartmentIdtodelete] =
    useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [departmentData, setDepartmentData] = useState({
    Id: "",
    Name: "",
    Narration: "",
    IsDirectApprove: false,
    CommonDataId: "",
    UserId: UID,
    IsSpDayApply: "",
    DepartmentHeadId: '',
    DesignationFilter: ''
  });
  const [selectedDesignationId, setSelectedDesignationId] = useState('');
  const [filteredEmployees, setfilteredEmployees] = useState([]);

  useEffect(() => {
    if (EmployeeDetails) {
      const filtered = EmployeeDetails.filter((emp) => {

        return emp.DesignationId === selectedDesignationId; // Ensure `return` here
      });
      setfilteredEmployees(filtered); // Directly set the filtered value
    }
  }, [selectedDesignationId, EmployeeDetails]);


  const clearData = () => {
    setDepartmentData({
      Id: "",
      Name: "",
      IsDirectApprove: false,
      Narration: "",
      CommonDataId: "",
      IsSpDayApply: false,
      UserId: UID,
      DepartmentHeadId: '',
      DesignationFilter: '',
      Profitcenter: 'Select Profit Center',

    })
    setSelectedDesignationId('')
  }

  const clearDataEdit = () => {
    setDepartmentData((ref) => ({
      ...ref,
      Name: "",
      Narration: "",
      CommonDataId: "",
      Profitcenter: 'Select Profit Center',
      IsSpDayApply: false,
      UserId: UID,
      DepartmentHeadId: '',
      DesignationFilter: '',
      IsDirectApprove: false,

    }));
    setSelectedDesignationId('')
  }

  const openModal = (DepartmentId) => {
    setDepartmentIdtodelete(DepartmentId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setDepartmentIdtodelete(null);
  };

  const confirmDelete = () => {
    if (DepartmentIdToDelete) {
      removedepartment(DepartmentIdToDelete);
    }
    closeModal();
  };
  const openEditDepartmentModal = (data) => {
    

    const CommonDataName = commonDatas.find((item) => {
      if (item.Id == data?.CommonDataId) {
        return item?.Name;
      }
    });
    setSelectedDesignationId(data?.DesignationFilter)
    setEditDepartmentModal(!editDepartmentModal);
    setDepartmentData({
      ...data,
      Profitcenter: CommonDataName?.Name,
      UserId: UID || "",
    });
  };



  const fetchDepartments = async () => {
    if (departments.length === 1) {
      return;
    }

    setLoading(true);
    try {
      const data = await getDepartments(UID);
      setDepartments(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching departments", error);
    } finally {
      setLoading(false);
    }
  };


  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;

    // Handle all input changes including checkboxes
    setDepartmentData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // If designation selection changes, update the filter and reset department head
    if (name === "DesignationFilter") {
      setSelectedDesignationId(value);

      // Reset the department head when designation changes
      setDepartmentData((prev) => ({
        ...prev,
        DepartmentHeadId: '',
      }));
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await insertDepartments(departmentData);
      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchDepartments();
        openAddDepartmentModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name or Code")) {
        toast.error("The Name  already in use on a Profitcenter. Please use difrent profitCenter");
      } else {
        toast.error("Error occurred while adding Departments.");
      }
      console.error("Error adding Departments:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      const response = await insertDepartments(departmentData);
      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchDepartments();
        openEditDepartmentModal();
      }

    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name or Code")) {
        toast.error("The Name already in use on Same Profitcenter ");
      } else {
        toast.error("Error occurred while editing Departments.");
      }
      console.error("Error editing Departments:", error);
    } finally {
      setLoading(false);
    }
  }
  const openAddDepartmentModal = () => {
    setDepartmentData({
      Id: "",
      Name: "",
      Narration: "",
      CommonDataId: "",
      UserId: UID,
      DepartmentHeadId: '',
      DesignationFilter: '',
      IsDirectApprove: false,

    })
    setSelectedDesignationId('')
    setAddDepartmentModal(!addDepartmentModal);

  };

  // remove
  const removedepartment = async (DepartmentIdToDelete) => {
    const removeData = { Id: DepartmentIdToDelete, TableName: "Departments" };

    try {
      const res = await deleteDepartments(removeData, UID);
      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Department deleted successfully");
          fetchDepartments(); // Refresh the list
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Department");
      } // Wait for fetch to complete
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Department.";
        toast.error('Department already using cannot delete');
      } else {
        console.error("Error removing Department:", error);
        toast.error("Error deleting Department. Please try again.");
      }
    }
  };


  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Department Name",
      selector: (row) => row.Name,
      sortable: true,
    },

    {
      name: "Code",
      selector: (row) => row.Code,
      sortable: true,
    },
    {
      name: "Department Head",
      selector: (row) => row.DepHeadName,
      sortable: true,
    },
    {
      name: "Profit Center",
      // selector: (row) => row.Profitcenter,
      // sortable: true,
      selector: (row) => {
        const profitCenter = commonDatas.find((el) => el.Id === row.CommonDataId);
        return profitCenter ? profitCenter.Name : "N/A"; // Handle case where category is not found
      },

    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditDepartmentModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];

  const filteredItems = dataFilter?.filter((item) => {
    const profitCenter = commonDatas.find((el) => el.Id === item.CommonDataId);
    const profitCenterName = profitCenter ? profitCenter.Name.toLowerCase() : "n/a";
    const lowerCaseFilterText = filterText.toLowerCase();

    return (
      item.Name.toLowerCase().includes(lowerCaseFilterText) ||
      item.Narration?.toLowerCase().includes(lowerCaseFilterText) ||
      profitCenterName.includes(lowerCaseFilterText) ||
      item.Code?.toString().toLowerCase().includes(lowerCaseFilterText)
    );
  });

  const subHeaderComponentMemo = useMemo(() => {


  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    setLoading(true);
    fetchDepartments();
  }, []);

  useEffect(() => {
    if (departments && departments.length > 0) {

      const updatedData = departments.map((item, index) => {
        const commonDataName =
          commonDatas.find((commonItem) => commonItem.Id === item.CommonDataId)
            ?.Name || "";

        return {
          Slno: index + 1,
          Id: item.Id || "",
          Name: item.Name || "",
          Code: item.Code || "",
          Narration: item.Narration || "",
          CommonDataId: item.CommonDataId || "",
          UserId: UID || "",
          Profitcenter: commonDataName,
          IsSpDayApply: item.IsSpDayApply || "",
          IsDirectApprove: item.IsDirectApprove || "",
          DepartmentHeadId: item.DepartmentHeadId || '',
          DepHeadName: item.DepHeadName || '',
          DesignationFilter: item.DesignationFilter || '',

        };
      });

      setDataFilter(updatedData);
    }
    else {
      setDataFilter([]);
    }

  }, [departments]);

  useEffect(() => {
    const fetchCommonDatas = async () => {
      setLoading(true); // Set loading to true when starting the fetch
      try {
        const response = await getProfitCenter(UID);
        setCommonDatas(response.data.data);
      } catch (error) {
        console.error("Error fetching deparments :", error);
      } finally {
        setLoading(false); // Set loading to false once fetch is complete
      }
    };

    fetchCommonDatas();
  }, []);
  const getemployee = async () => {
    try {
      const response = await getEmployee(UID);
      if (response?.data) {


        setEmployeeDetails(response?.data?.data);

      } else {
        console.warn("Response data is empty or undefined.");
      }
    } catch (error) {
      console.error("Error fetching personal details:", error);

    }
  };


  const [designation, setDesignation] = useState([])
  const fetchDesignation = async () => {
    try {
      const response = await getDesignation(UID);
      setDesignation(response.data.data);
    } catch (error) {
      console.error("Error fetching profit centers:", error);
    }
  };



  useEffect(() => {
    getemployee()
    fetchDesignation();
  }, [])



  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };


  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Department?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Department" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Dep/ProfitCenter/code"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddDepartmentModal}
            className="btn btn-primary"
          >
            Add New
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={departments} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>


      {addDepartmentModal && (
        <>
          <div className="fixed p-15 w-full max-w-[750px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">

              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add Department
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openAddDepartmentModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form
                onSubmit={handleSubmit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px] "
              >
                <div className="my-10 md:px-10 px-[7px] max-h-[75vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Department Name <span className="text-red-500"> *</span></label>
                      <input
                        type="text"
                        id="name"
                        name="Name"
                        placeholder="Name"
                        value={departmentData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>


                    <div className="form-group flex col-span-12 flex-row w-full ">
                      <label className="w-full">Leave restriction on special days </label>
                      <input
                        type="checkbox"
                        id="IsSpDayApply"
                        name="IsSpDayApply"
                        placeholder="IsSpDayApply"
                        value={departmentData.IsSpDayApply}
                        onChange={handleChange}
                        checked={!!departmentData.IsSpDayApply}

                      // checked={categoryData.IsSpDayApply}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Profit Center <span className="text-red-500"> *</span></label>
                      <select
                        name="CommonDataId"
                        value={departmentData.CommonDataId}
                        onChange={handleChange}
                        required
                      >
                        <option value="" selected disabled>Select Profit Center</option>
                        {commonDatas.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>Choose Designation</label>
                      <select
                        id="designationFilter"
                        name="DesignationFilter"
                        value={departmentData.DesignationFilter}
                        onChange={handleChange}
                      >
                        <option value="">Select Designation</option>
                        {designation.map((desig) => (
                          <option key={desig.Id} value={desig.Id}>
                            {desig.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    {/* Employee Select Box (appears only when designation is selected) */}
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>Department Head</label>
                      <select
                        id="departmentHead"
                        name="DepartmentHeadId"
                        value={departmentData.DepartmentHeadId}
                        onChange={handleChange}
                      >
                        <option value="">Select Department Head</option>
                        {filteredEmployees.map((emp) => (
                          <option key={emp.Id} value={emp.Id}>
                            {emp.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    <div className="form-group flex col-span-12 flex-row w-full ">
                      <label className="w-full">Directly Approve</label>
                      <input
                        type="checkbox"
                        id="IsDirectApprove"
                        name="IsDirectApprove"
                        placeholder="IsDirectApprove"
                        value={departmentData.IsDirectApprove}
                        onChange={handleChange}
                        checked={!!departmentData.IsDirectApprove}

                      // checked={categoryData.IsSpDayApply}
                      />
                    </div>
                    <div className="form-group flex col-span-12  flex-col">
                      <label>Remarks</label>

                      <input
                        type="text"
                        id="narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={departmentData.Narration}
                        onChange={handleChange}

                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                    disabled={loading}
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary" disabled={loading}>
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            // onClick={openAddDepartmentModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}



      {/* =========================================edit===================================================================== */}
      {editDepartmentModal && (
        <>
          <div className="fixed p-15 w-full max-w-[750px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">

              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit Department
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openEditDepartmentModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form
                onSubmit={handleEdit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px] "
              >
                <div className="my-10 md:px-10 px-[7px] max-h-[75vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Department Name <span className="text-red-500"> *</span></label>
                      <input
                        type="text"
                        id="Name"
                        name="Name"
                        placeholder="Name"
                        value={departmentData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>



                    <div className="form-group flex col-span-12 flex-row ">
                      <label htmlFor="IsSpDayApply" className="w-full">
                        Leave restriction on special days
                      </label>
                      <input
                        type="checkbox"
                        id="IsSpDayApply"
                        name="IsSpDayApply"
                        placeholder="IsSpDayApply"
                        checked={departmentData?.IsSpDayApply} // Set checked based on the condition
                        onChange={handleChange} // Handle the change event
                      // className="w-3 h-3" // Set width and height to 3/4 of default size
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Profit Center <span className="text-red-500"> *</span></label>
                      <select
                        name="CommonDataId"
                        value={departmentData.CommonDataId}
                        onChange={handleChange}
                        required
                      >
                        <option key="" value="" disabled selected>
                          Select ProfitCenter
                        </option>
                        {commonDatas.map((data) => (
                          <option key={data.Id} value={data.Id}>
                            {data.Name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group flex col-span-12 flex-col">
                      <label>Choose Designation</label>
                      <select
                        id="designationFilter"
                        name="DesignationFilter"
                        value={departmentData?.DesignationFilter}
                        onChange={handleChange}
                      >
                        <option value="">Select Designation</option>
                        {designation?.map((desig) => (
                          <option key={desig.Id} value={desig.Id}>
                            {desig.Name}
                          </option>
                        ))}
                      </select>
                    </div>

                
                    {/* Employee Select Box (appears only when designation is selected) */}
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Department Head</label>
                      <select
                        id="departmentHead"
                        name="DepartmentHeadId"
                        value={departmentData?.DepartmentHeadId}
                        onChange={handleChange}
                      >
                        <option value="">Select Department Head</option>
                        {filteredEmployees?.map((emp) => (
                          <option key={emp.Id} value={emp.Id}>
                            {emp.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-row w-full ">
                      <label className="w-full">Directly Approve</label>
                      <input
                        type="checkbox"
                        id="IsDirectApprove"
                        name="IsDirectApprove"
                        placeholder="IsDirectApprove"
                        value={departmentData.IsDirectApprove}
                        onChange={handleChange}
                        checked={!!departmentData.IsDirectApprove}

                      // checked={categoryData.IsSpDayApply}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks </label>
                      <input
                        type="text"
                        id="Narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={departmentData.Narration}
                        onChange={handleChange}

                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            // onClick={openEditDepartmentModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
